<motif-modal-title variant="alt">
    <button motifIconButton aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon [src]="'/assets/icons/navigation/ic_close_24px.svg'"></motif-icon>    </button>
</motif-modal-title>
<motif-modal-content>
    <div class="container">
        <div class="leftContainer">
            <div class="meeting-title">
                <h3>{{data.name}}</h3>
                <p>{{
                    data?.meetingDate | date : "dd/MM/yyyy"
                  }} , {{
                    data?.meetingDate | date : "HH:mm"
                  }}</p>
            </div>
            <img src="/assets/images/MeetingDetailsjpeg" alt="meeting details"/>
        </div>
        <div class="rightContainer">
            <img src="/assets/images/MeetingProgress.jpeg" alt="meeting progress details"/>
        </div>
    </div>
   
</motif-modal-content>
